import { useCallback } from 'react'
import { ApiRetailerPaymentType } from '@vend/types'
import { SalePayment } from '../PaymentModal/types'

export const useHandleLoyaltyPayment = (
  amountTendered: string,
  onPaymentSuccess: (result: SalePayment) => void
) => {
  const handleLoyaltyPayment = useCallback(
    (paymentType: ApiRetailerPaymentType) => {
      // TODO: Implement loyalty payment handling
    },
    []
  )
  return {
    handleLoyaltyPayment,
  }
}
